// Lightweight logger wrapper. Uses console in development and no-ops in production.
const isProd = process.env.NODE_ENV === 'production';

const safe = (...args) => {
    if (!isProd) console.log(...args);
};

const info = (...args) => {
    if (!isProd) console.info(...args);
};

const warn = (...args) => {
    if (!isProd) console.warn(...args);
};

const error = (...args) => {
    if (!isProd) console.error(...args);
};

export default {
    safe,
    info,
    warn,
    error
};
